import React from 'react';
import PropTypes from 'prop-types';

const TrackingContext = React.createContext({});

export const TrackingMethods = ({ methods, ...props }) => (
  <TrackingContext.Provider {...props} value={methods} />
);
TrackingMethods.propTypes = {
  methods: PropTypes.object.isRequired,
};

export const withTrackingMethods = (Component) =>
  class extends React.Component {
    static displayName = `withTrackingMethods(${
      Component.displayName || Component.name
    })`;

    static contextType = TrackingContext;

    render() {
      return (
        <TrackingContext.Consumer>
          {(methods) => <Component {...methods} {...this.props} />}
        </TrackingContext.Consumer>
      );
    }
  };
